import React from 'react'
import { Table } from '../../components'
import { checkNegative, STRING } from '../../helpers'
import NumberFormat from 'react-number-format'

export class EarningStatementTable extends React.Component {
  render() {
    const { info } = this.props
    return info && info.length ? (
      <Table className="theme-pink earning-statement financial-score">
        <Table.THEAD>
          <Table.TR className="header">
            <Table.TH className="detail-list"></Table.TH>

            <Table.TH colSpan="2">{info[0].FISCAL_YEAR - 543}</Table.TH>

            <Table.TH colSpan="2">{info[1].FISCAL_YEAR - 543}</Table.TH>

            <Table.TH colSpan="2">{info[2].FISCAL_YEAR - 543}</Table.TH>
          </Table.TR>

          <Table.TR className="sub-header">
            <Table.TD className="detail-list">
              {STRING.PROFIT_LOSS_STATEMENT}
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className="year-detail">
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>
          </Table.TR>
        </Table.THEAD>

        <Table.TBODY>
          {/* data content below [mockup data] */}
          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.REVENUE_SALES_SERVICES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN01)}`}
            >
              {info[0].BAL_IN01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN01_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN01_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN01)}`}
            >
              {info[1].BAL_IN01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN01_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN01_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN01)}`}
            >
              {info[2].BAL_IN01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN01_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN01_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.TOTAL_REVENUE}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN09)}`}
            >
              {info[0].BAL_IN09 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN09}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN09_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN09_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN09)}`}
            >
              {info[1].BAL_IN09 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN09}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN09_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN09_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN09)}`}
            >
              {info[2].BAL_IN09 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN09}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN09_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN09_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.COST_OF_GOOD}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN10)}`}
            >
              {info[0].BAL_IN10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN10_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN10)}`}
            >
              {info[1].BAL_IN10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN10_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN10)}`}
            >
              {info[2].BAL_IN10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN10_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN10_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.GROSS_PROFIT}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].GROSS_PROFIT_MARGIN
              )}`}
            >
              {info[0].GROSS_PROFIT_MARGIN == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].GROSS_PROFIT_MARGIN}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN01_10_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN01_10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN01_10)}`}
            >
              {info[1].BAL_IN01_10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN01_10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN01_10_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN01_10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN01_10)}`}
            >
              {info[2].BAL_IN01_10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN01_10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN01_10_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN01_10_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.SELLING_ADMIN_EXPENSES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN11)}`}
            >
              {info[0].BAL_IN11 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN11}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN11_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN11_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN11)}`}
            >
              {info[1].BAL_IN11 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN11}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN11_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN11_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN11)}`}
            >
              {info[2].BAL_IN11 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN11}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN11_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN11_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.TOTAL_EXPENSES}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN20)}`}
            >
              {info[0].BAL_IN20 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN20}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN20_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN20_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN20)}`}
            >
              {info[1].BAL_IN20 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN20}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN20_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN20_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN20)}`}
            >
              {info[2].BAL_IN20 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN20}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN20_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN20_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.INTEREST_EXPENSES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN12)}`}
            >
              {info[0].BAL_IN12 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN12}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN12_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN12_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN12)}`}
            >
              {info[1].BAL_IN12 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN12}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN12_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN12_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN12)}`}
            >
              {info[2].BAL_IN12 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN12}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN12_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN12_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.PROFIT_INCOME_TAX}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN28)}`}
            >
              {info[0].BAL_IN28 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN28}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN28_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN28_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN28)}`}
            >
              {info[1].BAL_IN28 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN28}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN28_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN28_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN28)}`}
            >
              {info[2].BAL_IN28 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN28}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN28_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN28_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="detail-list">{STRING.INCOME_TAX}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN19)}`}
            >
              {info[0].BAL_IN19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN19_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN19_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN19)}`}
            >
              {info[1].BAL_IN19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN19_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN19_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN19)}`}
            >
              {info[2].BAL_IN19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN19_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN19_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
          <Table.TR>
            <Table.TD className="detail-list">{STRING.NET_PROFIT}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_IN21)}`}
            >
              {info[0].BAL_IN21 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_IN21}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_IN21_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_IN21_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_IN21)}`}
            >
              {info[1].BAL_IN21 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_IN21}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_IN21_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_IN21_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_IN21)}`}
            >
              {info[2].BAL_IN21 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_IN21}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_IN21_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_IN21_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>
      </Table>
    ) : null
  }
}
